import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import { Button as GridButton } from '../../../../Components/MUIs';
import { Tooltip } from '@mui/material';

/** 직책 콤보박스 옵션 */
const ALLOWED_POSITION_OPTIONS = [
  '관리감독자',
  '안전보건총괄책임자',
  '안전보건관리책임자',
];

export const getColumnDefs1 = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: props.DeleteNewRow1,
      RestoreRow1: props.RestoreRow1,
      gridRef1: props.gridRef1,
      rowData1: props.rowData1,
      selectedRowNosRef: props.selectedRowNosRef1,
      lastCheckedIndexRef: props.lastCheckedIndexRef1,
      handleRowSelection: props.HandleRowSelection1,
    },
    maxWidth: 100,
  }),
  CreateColumn(
    'managerId',
    '관리자ID',
    'left',
    100,
    false,
    false,
    true,
    'text'
  ),
  CreateColumn('depNm', '부서', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    flex: 1,
  }),
  CreateColumn('rank', '직위', 'left', 150, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    minWidth: 150,
  }),
  CreateColumn('managerNm', '성명', 'left', 250, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    minWidth: 250,
  }),
  CreateColumn('position', '직책', 'left', 200, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    flex: 1,
  }),
  CreateColumn('manageDate', '선임일', 'left', 150, true, false, false, 'date'),

  // 7. 파일 업로드 (upload 타입 활용)
  CreateColumn(
    'fileName',
    '파일업로드',
    'center',
    300,
    false,
    false,
    false,
    'fileButton',
    {
      pinned: 'right',
      fileButtonClickHandler: (data, fieldName) => {
        props.PopupFileClickEvent?.(data);
      },
      fileButtonFileNameKey: 'fileName',
      fileButtonFilePathKey: 'filePath',
      minWidth: 200,
    }
  ),

  CreateColumn('', '평가표', 'center', 100, false, false, false, 'button', {
    buttonText: '이동',
    buttonRenderer: (params) => {
      const hasManageDate = !!params.data?.manageDate;
      const isAllowedPositions = ALLOWED_POSITION_OPTIONS.includes(
        params.data?.position
      );

      const isEnabled = hasManageDate && isAllowedPositions;

      let tooltipTitle = '';
      if (!hasManageDate) {
        tooltipTitle = '선임일이 등록된 경우에만 평가가 가능합니다';
      } else if (!isAllowedPositions) {
        tooltipTitle =
          '관리감독자, 안전보건총괄책임자, 안전보건관리책임자만 평가가 가능합니다.';
      }

      const button = (
        <GridButton
          size="small"
          name="이동"
          sx={{ width: '100%' }}
          disabled={!isEnabled}
          onClick={() => {
            if (!isEnabled) return;
            const rowData = params.data;
            if (!rowData) {
              if (props.dispatch && props.showSnackbar) {
                props.dispatch(
                  props.showSnackbar({
                    message: '항목을 선택하세요.',
                    type: 'warning',
                  })
                );
              }
              return;
            }
            if (props.handleEvaluationClick) {
              props.handleEvaluationClick(rowData);
            }
          }}
        />
      );
      return !isEnabled ? (
        <Tooltip title={tooltipTitle} arrow>
          <span style={{ display: 'inline-block', width: '100%' }}>
            {button}
          </span>
        </Tooltip>
      ) : (
        button
      );
    },
    pinned: 'right',
  }),
];
export const getColumnDefs2 = (props) => [
  CreateColumn('no', 'NO', 'left', 100, false, false, false, 'checkbox', {
    checkboxProps: {
      DeleteNewRow1: props.DeleteNewRow1,
      RestoreRow1: props.RestoreRow1,
      gridRef1: props.gridRef2,
      rowData1: props.evaluationListData,
      selectedRowNosRef: props.selectedRowNosRef2,
      lastCheckedIndexRef: props.lastCheckedIndexRef2,
      handleRowSelection: props.HandleRowSelection2,
    },
    maxWidth: 100,
  }),
  CreateColumn('depNm', '부서', 'left', 150, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    flex: 1,
  }),
  CreateColumn('rank', '직위', 'left', 150, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    minWidth: 150,
  }),
  CreateColumn('managerNm', '성명', 'left', 150, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    flex: 1,
  }),
  CreateColumn('position', '직책', 'left', 180, false, false, false, 'text', {
    cellClass: 'none-editable-cell',
    minWidth: 180,
  }),
  CreateColumn(
    'evaStartDate',
    '평가기간(시작)',
    'left',
    150,
    false,
    false,
    false,
    'date',
    {
      cellClass: 'none-editable-cell',
    }
  ),
  CreateColumn(
    'evaEndDate',
    '평가기간(종료)',
    'left',
    150,
    false,
    false,
    false,
    'date',
    {
      cellClass: 'none-editable-cell',
    }
  ),
];
/**
 * 모든 컬럼 정의 내보내기
 */
export default {
  getColumnDefs1,
  getColumnDefs2,
};
